import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../hooks/redux';
import { useLicenseCheck } from '../hooks/useLicenseCheck';
import { usePermissions } from '../hooks/usePermissions';

interface GoogleReviewGuardProps {
  children: React.ReactNode;
}

const GoogleReviewGuard: React.FC<GoogleReviewGuardProps> = ({ children }) => {
  const { t } = useTranslation();

  const isDataInitialized = useAppSelector((state) => state.auth.isDataInitialized);
  const hasLicense = useLicenseCheck('google_review_manager');
  const { can } = usePermissions();

  if (!isDataInitialized) return null;

  if (!can('google_review_read')) {
    return (
      <div className="dashboard-empty-state">
        <p className="dashboard-empty-state-text">{t('subuser_no_permission_title')}</p>
        <p className="dashboard-empty-state-hint">{t('subuser_no_permission_description')}</p>
      </div>
    );
  }

  if (!hasLicense) {
    return (
      <div className="dashboard-empty-state">
        <p className="dashboard-empty-state-text">{t('google_review_license_required_title')}</p>
        <p className="dashboard-empty-state-hint">{t('google_review_license_required_description')}</p>
        <Link to="/licenses/buy?plugin=google_review_manager" className="dashboard-empty-state-btn">
          {t('google_review_get_license_button')}
        </Link>
      </div>
    );
  }

  return <>{children}</>;
};

export default GoogleReviewGuard;
